.root {
  display: grid;
  gap: 72px;
}
